<template>
	<div v-loading.fullscreen.lock="fullscreenLoading">
		<TopHeader :tabIndex='3'></TopHeader>
		<div class="topBg" :class="memberInfo.level==1?'topBg':'topBg2'"></div>
		<div class="cont">
			<div class="flex flex-b">
				<div class="flex">
					<div class="headImg">
						<img :src="userInfo.img"
							style="width: 89px;height: 89px;border-radius: 50%;border: 2px solid #E1E1E1;" alt="" />
						<div class="vipBox flex flex-c-c" :class="memberInfo.level!=1?'vipBox2':''">
							<img v-if="memberInfo.name=='基础会员'" src="../../assets/images/icon/ivip.png"
								style="width: 16px;height: 16px;margin-right: 6px;" alt="" />
							<img v-else src="../../assets/images/icon/ivip2.png"
								style="width: 16px;height: 16px;margin-right: 6px;" alt="" />
							<div class="vipName">{{memberInfo.name}}</div>
						</div>
						<img class="hg" src="../../assets/images/icon/ihg2.png" style="width: 31px;height: 27px;"
							alt="" />
					</div>
					<div style="margin-left: 20px;">
						<div class="flex pointer" @click="editInfo=true">
							<div class="name">{{userInfo.name}}</div>
							<img src="../../assets/images/icon/iedit.png" style="width: 22px;height: 22px;" alt="" />
						</div>
						<div class="time color" v-if="userInfo.member_time">会员到期时间：{{userInfo.member_time}}</div>
						<div class="time color" v-else>基础会员</div>
						<div class="flex">
							<div class="company" v-if="!userInfo.bussiness_name">
								{{userInfo.business?userInfo.business:'暂未绑定企业'}}</div>
							<div class="company" v-else>{{userInfo.bussiness_name?userInfo.bussiness_name:'暂未绑定企业'}}
							</div>
							<div class="flex-1"></div>
						</div>
					</div>
				</div>
				<div class="flex flex-b borbox">
					<div class="flex-column-item">
						<div class="t1">{{userInfo.finish}}</div>
						<div class="t2">完成课程数</div>
					</div>
					<div class="flex-column-item">
						<div class="t1">{{userInfo.login_day}}</div>
						<div class="t2">累计登录天数</div>
					</div>
					<div class="flex-column-item">
						<div class="t1">{{userInfo.score}}</div>
						<div class="t2">我的积分</div>
					</div>
				</div>
			</div>
			<div class="flex-only flex-b" style="margin-top: 20px;">
				<div class="left">
					<div class="flex flex-b">
						<div class="titles">我的课程</div>
						<div class="flex pointer" @click="toPage(0,'/allCourse')">
							<div class="all">查看全部</div>
							<img src="../../assets/images/home/arrow_r.png" style="width: 13px;height: 13px;" alt="" />
						</div>
					</div>
					<div class="navs flex">
						<div class="navItem pointer" :class="navIndex==1?'active':''" @click="changeNavIndex(1)">未学习
						</div>
						<div class="navItem pointer" :class="navIndex==2?'active':''" @click="changeNavIndex(2)">学习中
						</div>
						<div class="navItem pointer" :class="navIndex==3?'active':''" @click="changeNavIndex(3)">已完成
						</div>
						<div class="navItem pointer" :class="navIndex==0?'active':''" @click="changeNavIndex(0)">收藏列表
						</div>
					</div>
					<div class="flex flex-wrap">
						<div class="itembg1 pointer" v-for="item in courseList" v-if="courseList.length>0">
							<img :src="item.img" style="width: 100%;border-radius: 13px;max-height: 147px;"
								@click="goDetail(item)" />
							<div class="ititle">{{item.name}}</div>
							<div class="flex flex-b">
								<div class="flag flex flex-c">{{item.course_category_name}}</div>
								<!-- <div class="flag1">加工中心学院</div> -->
							</div>
							<div class="sc flex pointer" v-if="navIndex==0" @click="delCollect(item.course_uuid)">
								<img src="../../assets/images/icon/isc.png"
									style="width: 16px;height: 16px;margin-right: 6px;" />
								取消收藏
							</div>
							<div class="status" v-if="item.status==1">未学习</div>
							<div class="status status2" v-if="item.status==2">学习中</div>
							<div class="status status3" v-if="item.status==3">已完成</div>
						</div>
						<div class="nodata" v-if="courseList.length==0">
							<div>暂无数据</div>
						</div>
					</div>
				</div>
				<div class="right">
					<img v-if="bannerList.length!=0" :src="bannerList[0].img" @click="toBanner(bannerList[0])"
						style="width: 100%;height: 74px;" alt="" />
					<div class="toolBox">
						<div class="tit">快捷入口</div>
						<div class="flex flex-b flex-wrap">
							<div class="item flex-column-item pointer" v-for="(item,index) in list" :key="index"
								@click="toPage(index,item.url)">
								<img :src="item.icon" style="width: 27px;height: 27px;" alt="" />
								<div class="t">{{item.name}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 编辑个人信息 -->
		<el-dialog :visible.sync="editInfo" width="500px" :close-on-click-modal='false' :show-close="true"
			:close-on-press-escape='false'>
			<div class="editInfo">
				<div class="tit t-c">编辑个人信息</div>
				<div class="headImg flex flex-c-c">
					<el-upload :limit="1" class="avatar-uploader" :action="uplodUrl" :show-file-list="false"
						:on-success="handleAvatarSuccess">
						<img :src="userInfo.img" style="width: 107px;height: 107px;border-radius: 50%;" alt="" />
						<img class="edit" src="../../assets/images/mine/edit2.png" style="width: 36px;height: 36px;"
							alt="" />
					</el-upload>
				</div>
				<div class="gbox">
					<div class="infoItem flex flex-b">
						<div class="t1 w-33">昵称</div>
						<input class="inpt flex-1" type="text" v-model="updateUserInfo.name" placeholder="请输入昵称" />
					</div>
					<div class="infoItem flex flex-b">
						<div class="t1 w-33">性别</div>
						<div class="flex flex-1">
							<el-radio-group class="flex" v-model="updateUserInfo.gender">
								<el-radio :label="1" border>男</el-radio>
								<el-radio :label="2" border>女</el-radio>
							</el-radio-group>
						</div>
					</div>
					<div class="infoItem flex flex-b">
						<div class="flex w-33">
							<div class="t1">手机号</div>
							<div class="change pointer" @click="changePhone=true">更改</div>
						</div>
						<div class="inpt flex-1">{{updateUserInfo.phone}}</div>
					</div>
					<div class="infoItem flex flex-b">
						<div class="t1 w-33">所属企业</div>
						<input class="inpt flex-1" v-if="!updateUserInfo.bussiness_name" type="text"
							v-model="updateUserInfo.business" placeholder="请输入企业" />
						<input class="inpt flex-1" v-if="updateUserInfo.bussiness_name" :disabled='true' type="text"
							v-model="updateUserInfo.bussiness_name" placeholder="请输入企业" />
					</div>
					<div class="infoItem flex flex-b">
						<div class="t1 w-33">现有机型</div>
						<textarea class="inpt flex-1" style="height: 150px;"
							v-model="updateUserInfo.phone_type"></textarea>
					</div>
				</div>
				<div class="login-btn pointer" @click="saveClick" style="margin-top: 20px;width: 436px;height: 46px;">
					<span class="text">保 存</span>
				</div>
			</div>
		</el-dialog>
		<!-- 修改手机号 -->
		<el-dialog :visible.sync="changePhone" width="438px" :close-on-click-modal='false' :show-close="true"
			:close-on-press-escape='false'>
			<div class="changePhone">
				<div class="tit">修改绑定手机号</div>
				<div class="ct1">验证绑定手机号</div>
				<div class="ct2">修改绑定手机好需要验证进行短信验证</div>
				<div class="inputbg flex">
					<img src="../../assets/images/login/sj.png" style="width: 20px;height: 20px;" />
					<el-dropdown @command='selectCode'>
						<div class="areacode">{{areaCode}}</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command='+86'>+86</el-dropdown-item>
							<el-dropdown-item command='+886'>+886</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<input v-model="newPhone" class="input" placeholder="请输入新手机号" autocomplete="new-password">
				</div>
				<div class="inputbg flex flex-b" style="margin-top: 21px;">
					<div class="flex">
						<img src="../../assets/images/login/mm.png" style="width: 20px;height: 20px;" />
						<input class="input" v-model="code" type="text" placeholder="请输入验证码"
							autocomplete="new-password">
					</div>
					<div class="code" v-if="second == 60" @click="send">获取验证码</div>
					<div class="sec" v-else>{{second}}s后再次获取</div>
				</div>
				<div class="login-btn pointer" style="width: 387px;height: 46px;" @click="confirm">
					<span class="text">确 认</span>
				</div>
			</div>
		</el-dialog>
		<toTop></toTop>
		<Footer ref="footerRef"></Footer>

		<MemberCenter ref="memberCenterRef"></MemberCenter>
		<PointsCom ref="pointsComRef"></PointsCom>
	</div>
</template>

<script>
	import {
		urlDomain,
		imgDomain
	} from '@/configs/env.js'
	import Utils from "@/jslibs/utils";
	import {
		getCollect,
		delCollect,
		getCourseDetail
	} from '@/api/course';
	import {
		getMyCourse,
		getUser,
		EditUser,
		getBannerTopList,
		SendSmsCode
	} from '@/api/mine';
	import MemberCenter from '@/components/MemberCenter.vue'
	import TopHeader from "../../components/TopHeader.vue";
	import Footer from "../../components/Footer.vue";
	import toTop from '../../components/toTop.vue'
	import PointsCom from '@/components/PointsCom.vue'
	export default {
		data() {
			return {
				areaCode: '+86',
				navIndex: 1, //课程状态
				list: [{
						icon: require('../../assets/images/mine/ico1.png'),
						name: '邀请好友',
						url: '/invite'
					}, {
						icon: require('../../assets/images/mine/ico2.png'),
						name: '会员中心',
						url: 'dialog'
					}, {
						icon: require('../../assets/images/mine/ico3.png'),
						name: '我的培训',
						url: '/myTraining'
					}, {
						icon: require('../../assets/images/mine/ico4.png'),
						name: '我的积分',
						url: 'dialog'
					}, {
						icon: require('../../assets/images/mine/ico5.png'),
						name: '购物车',
						url: '/myCart'
					}, {
						icon: require('../../assets/images/mine/ico6.png'),
						name: '消息通知',
						url: '/message'
					},
					// {
					// 	icon:require('../../assets/images/mine/ico7.png'),
					// 	name:'设置',
					// 	url:'dialog'
					// }
				],
				tabIndex: 0,
				addPoints: [{
					icon: require('../../assets/images/mine/imine1.png'),
					name: '每日登录',
					num: 5
				}, {
					icon: require('../../assets/images/mine/imine2.png'),
					name: '邀请用户',
					num: 10
				}, {
					icon: require('../../assets/images/mine/imine3.png'),
					name: '完成章节学习',
					num: 10
				}, {
					icon: require('../../assets/images/mine/imine4.png'),
					name: '分享已购课程',
					num: 10
				}, {
					icon: require('../../assets/images/mine/imine5.png'),
					name: '评论已购课程',
					num: 10
				}, {
					icon: require('../../assets/images/mine/imine6.png'),
					name: '线下培训签到',
					num: 10
				}],
				showPointsRule: false, //积分规则弹窗
				openRecord: false, //开通记录
				editInfo: false, //修改个人信息
				changePhone: false,
				courseList: [],

				userInfo: '',
				updateUserInfo: '',
				memberInfo: '',
				second: 60,
				newPhone: '',
				code: '',
				uplodUrl: '',
				bannerList: [],
				fullscreenLoading: true
			}
		},
		components: {
			TopHeader,
			Footer,
			toTop,
			MemberCenter,
			PointsCom
		},
		mounted() {
			this.uplodUrl = urlDomain + '/v1/common/Upload'
			this.getMyCourse()
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			} else {
				this.$message.warning('未登录')
			}
			this.getBannerTopList()
		},
		methods: {
			selectCode(e) {
				this.areaCode = e
			},
			toBanner(item) {
				if (item.link_type == 1) {
					//指定课程
					this.getCourseDetail(item.course_uuid)
				}
				if (item.link_type == 2) {
					//指定培训
					this.$router.push({
						path: '/trainingDetail?id=' + item.train_uuid
					})
				}
				if (item.link_type == 3) {
					//固定页面-关于我们
					this.$router.push({
						path: '/about'
					})
				}
				if (item.link_type == 4) {
					//固定页面-服务据点
					this.$refs.footerRef.openService()
				}
				if (item.link_type == 5) {
					//核心技术
					this.$router.push({
						path: '/telenology'
					})
				}
				if (item.link_type == 6) {
					//外部链接
					window.open(item.url)
				}
			},
			async getCourseDetail(id) {
				const {
					status,
					data
				} = await getCourseDetail({
					uuid: id,
				});
				if (data.result.vis == 2) {
					return this.$message.warning('课程已下架')
				}
				this.$router.push({
					path: '/courseDetail',
					query: {
						id: data.result.uuid,
						course_cate_name: data.result.course_cate_name
					}
				})
			},
			async getBannerTopList() {
				const {
					status,
					data
				} = await getBannerTopList({
					type: 3
				})
				this.bannerList = data.result
			},
			handleAvatarSuccess(res, file) {
				this.userInfo.img = imgDomain + res.result
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			// send() {
			// 	if (!this.newPhone) {
			// 		this.$message.warning('请输入新的电话号码')
			// 	} else if (this.newPhone.length !== 11) {
			// 		this.$message.warning('请输入正确的电话号码')
			// 	} else {
			// 		const interverId = setInterval(() => {
			// 			this.second--
			// 			if (this.second < 1) {
			// 				this.second = 10
			// 				clearInterval(interverId)
			// 			}
			// 		}, 1000)
			// 	}
			// },
			async send() {
				if (!this.newPhone) {
					this.$message({
						message: "请输入手机号",
						type: "warning"
					});
					return
				}
				this.resetCode()
				const {
					status,
					data
				} = await SendSmsCode({
					phone: this.areaCode + this.newPhone,
				})
				if (status != 200) return
				this.$message({
					message: "发送成功",
					type: "success"
				});
			},
			resetCode() {
				this.second -= 1
				let interval = setInterval(() => {
					if (this.second > 0) {
						this.second -= 1
					} else {
						this.second = 60
						clearInterval(interval)
					}
				}, 1000)
			},
			async confirm() {
				if (!this.newPhone) return this.$message.success('请输入手机号')
				if (!this.code) return this.$message.success('请输入验证码')
				const {
					status,
					data
				} = await EditUser({
					phone: this.areaCode+this.newPhone,
					code: this.code,
					uuid: this.updateUserInfo.uuid,
				})
				if (data.result == true) {
					this.$message.success('修改成功')
				} else {
				}
				this.changePhone = false
				this.getUser()
				this.newPhone = ''
				this.code = ''
			},
			async saveClick() {
				this.EditUser()
				this.editInfo = false
			},
			async EditUser() {
				const {
					status,
					data
				} = await EditUser({
					name: this.updateUserInfo.name,
					business: this.updateUserInfo.business,
					phone_type: this.updateUserInfo.phone_type,
					gender: this.updateUserInfo.gender,
					// phone: this.updateUserInfo.phone,
					// code: this.code,
					uuid: this.updateUserInfo.uuid,
					img: this.userInfo.img
				})
				if (data.result == true) {
					this.$message.success('修改成功')
				} else {
					this.$message.error('修改失败')
				}
				this.getUser()
			},
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.userInfo = data.result
				this.updateUserInfo = Object.assign({}, data.result)
				this.memberInfo = data.result.member
				Utils.setCookie("loginUser", JSON.stringify(this.userInfo), 7); // TODO: 先设三天过期  */
			},
			//跳转详情页
			goDetail(item) {
				console.log(123)
				this.$router.push({
					path: '/myCourseDetail',
					query: {
						id: item.course_uuid,
						course_category_name: item.course_category_name
					}
				})
			},
			changeNavIndex(e) {
				this.navIndex = e
				if (e == 0) {
					this.getCollect()
				} else {
					this.getMyCourse()
				}
			},
			//我的课程
			async getMyCourse() {
				const {
					status,
					data
				} = await getMyCourse({
					status: this.navIndex
				})
				this.courseList = data.result.data
				this.fullscreenLoading = false
			},
			//我的收藏
			async getCollect() {
				const {
					status,
					data
				} = await getCollect({})
				this.courseList = data.result.data
			},
			//取消收藏
			async delCollect(id) {
				const {
					status,
					data
				} = await delCollect({
					uuid: id,
				})
				if (status == 200) {
					this.$message({
						message: "取消收藏成功",
						type: "success"
					});
				}
				this.getCollect()
			},
			toPage(index, url) {
				if (index == 1) {
					this.$refs.memberCenterRef.openDialog()
				} else if (index == 3) {
					this.$refs.pointsComRef.openDialog()
				} else if (index == 6) {
					this.editInfo = true
				} else {
					this.$router.push({
						path: url
					})
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	::v-deep .el-dialog__header {
		padding: 0;
	}

	::v-deep .el-dialog__body {
		padding: 0;
	}

	::v-deep .el-dialog__close:hover {
		color: #999;
	}

	::v-deep .el-dialog__headerbtn {
		font-size: 24px;
	}

	::v-deep .el-radio-group {
		flex: 1;
		display: flex;
	}

	::v-deep .el-radio {
		width: 50% !important;
	}

	::v-deep .el-radio__input {
		display: none !important;
	}

	::v-deep .el-radio__label {
		padding-left: 0;
	}

	.topBg {
		width: 100%;
		height: 192px;
		background: linear-gradient(270deg, #96B1C4 0%, #D4E1ED 100%);
	}

	.topBg2 {
		width: 100%;
		height: 192px;
		background: linear-gradient(270deg, #FAC55C 0%, #FFE787 100%) !important;
	}

	.color {
		color: #C99922 !important;
	}

	.cont {
		margin: -160px 166px 0;
		padding: 30px;
		background: #FFFFFF;
		box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
		border-radius: 13px 13px 13px 13px;

		.headImg {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;

			.vipBox {
				// position: absolute;
				bottom: -10px;
				left: 50%;
				// transform: translateX(-50%);
				margin-top: -20px;
				width: 100%;
				height: 33px;
				line-height: 33px;
				background: linear-gradient(270deg, #96B1C4 0%, #D4E1ED 100%);
				border-radius: 13px 13px 13px 13px;
				border: 1px solid rgba(255, 255, 255, 0.36);

				.vipName {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 14px;
					color: #333333;
				}
			}

			.vipBox2 {
				background: linear-gradient(270deg, #FAC55C 0%, #FFE787 100%) !important;
			}

			.hg {
				position: absolute;
				top: -5px;
				left: -5px;
			}
		}

		.name {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 22px;
			color: #000000;
			margin-right: 6px;
		}

		.time {
			margin: 6px 0;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #999999;
		}

		.company {
			height: 22px;
			line-height: 22px;
			padding: 0 6px;
			background: rgba(0, 167, 60, 0.06);
			border-radius: 4px 4px 4px 4px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #00A73C;
		}

		.borbox {
			width: 40%;
			border-radius: 13px 13px 13px 13px;
			border: 1px solid #EEEEEE;
			padding: 20px;

			.t1 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: bold;
				font-size: 18px;
				color: #333333;
			}

			.t2 {
				margin-top: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
			}
		}

		.left {
			width: 70%;

			.titles {
				margin: 10px 0;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 20px;
				color: #000000;
				position: relative;
				z-index: 2;

				&::after {
					position: absolute;
					content: '';
					z-index: -1;
					bottom: 4px;
					left: 0;
					width: 53px;
					height: 4px;
					background: linear-gradient(141deg, #10B649 0%, #7FDA4C 100%);
				}
			}

			.all {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #999999;
			}

			.navs {
				margin-bottom: 10px;

				.navItem {
					margin-right: 20px;
					height: 36px;
					padding: 0 16px;
					background: #FFFFFF;
					border-radius: 9px 9px 9px 9px;
					border: 1px solid #EEEEEE;
					opacity: 0.8;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
					line-height: 36px;
				}

				.active {
					background: rgba(0, 167, 60, 0.06);
					border-radius: 9px 9px 9px 9px;
					opacity: 0.8;
					color: #00A73C;
				}
			}
		}

		.right {
			flex: 1;
			margin-left: 30px;
			min-height: 100%;

			.toolBox {
				margin-top: 30px;
				background: linear-gradient(180deg, #EBFAF0 0%, #FAFDFB 14%, #FFFFFF 100%);
				border-radius: 13px 13px 13px 13px;
				padding: 20px;

				.tit {
					margin-bottom: 20px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 20px;
					color: #000000;
				}

				.item {
					width: 33%;
					margin-bottom: 30px;

					.t {
						margin-top: 4px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 16px;
						color: #666666;
					}
				}
			}
		}

		.itembg1 {
			// min-width: calc(34% - 27px);
			width: calc(34% - 27px);
			margin-right: 27px;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			background: #FFFFFF;
			border-radius: 13px 13px 13px 13px;
			padding: 9px 11px 16px 11px;
			position: relative;
			margin-bottom: 14px;

			&:nth-child(3n) {
				margin-right: 0;
			}

			.status {
				position: absolute;
				right: 0;
				top: 0;
				height: 22px;
				background: #00A73C;
				border-radius: 0px 13px 0px 9px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #FFFFFF;
				line-height: 22px;
				padding: 0 10px;

				&.status2 {
					background: #D7B155;
				}

				&.status3 {
					background: #FC5F5F;
				}
			}

			.ititle {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #000000;
				margin-top: 13px;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
			}

			.addItem {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
			}

			.flag {
				margin: 10px 0 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #D7B155;
			}

			.flag1 {
				margin: 10px 0 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}

			.sc {
				margin-top: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
			}
		}
	}

	.login-btn {
		width: 550px;
		height: 46px;
		background: url('../../assets/images/login/loginbtn.png') no-repeat;
		background-size: 100% 100%;
		margin-top: 13px;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.dialog {
		background: #fff;
		border-radius: 10px;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #CCCCCC;
		}

		.tit {
			line-height: 60px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 20px;
			color: #000000;
		}

		.t {

			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
		}

		.head {
			width: 671px;
			height: 340px;
			background-image: url('../../assets/images/mine/jfBg.png');
			background-size: 100%;
			padding: 0 30px;

			.jf {
				margin-left: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: bold;
				font-size: 31px;
				color: #00A73C;
			}

			.rule {
				margin-right: 200px;
				height: 27px;
				padding: 0 6px;
				background: #A8C9B4;
				border-radius: 11px 11px 11px 11px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #FFFFFF;
				line-height: 27px;
			}

			.long {
				margin-top: -40px;
				width: 100%;
				height: 62px;
				background-image: url('../../assets/images/mine/longBg.png');
				background-size: 100%;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 18px;
				color: #000000;
				padding: 20px;
				text-align: right;

				span {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 18px;
					color: #00A73C;
				}
			}

			.date {
				background: #FFFFFF;
				border-radius: 0 0 20px 20px;
				padding: 0 20px 20px;

				.line {
					height: 31px;
					background: #F7F7F7;
					border-radius: 9px 9px 9px 9px;
					padding: 0 30px;
				}

				.add {
					width: 50px;
					margin-top: -20px;
					padding: 24px 0 10px;
					background: #F7F7F7;
					border-radius: 9px 9px 9px 9px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					text-align: center;
					font-weight: 500;
					font-size: 13px;
					color: #BABABC;

					&.add1 {
						border: 1px solid #C2EAD0;
						background: transparent;
						white-space: nowrap;
						color: rgba(0, 167, 60, 0.56);
					}

					&.add2 {
						background: #00A73C;
						color: #FFFFFF;
					}
				}

				.time {
					margin-top: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #EACF8C;
				}
			}
		}

		.jfList {
			padding: 20px;

			.tabs {
				padding: 0 80px;
				margin-bottom: 20px;
				align-items: center;
				justify-content: space-around;

				.tabItem {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 18px;
					color: #666666;
				}

				.active {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 18px;
					color: #000000;
					position: relative;
					z-index: 2;

					&::after {
						position: absolute;
						content: '';
						z-index: -1;
						bottom: 4px;
						left: 0;
						width: 53px;
						height: 4px;
						background: linear-gradient(141deg, #10B649 0%, #7FDA4C 100%);
					}
				}
			}

		}

		.wbox {
			height: 350px;
			overflow-y: scroll;
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;

			.item {
				padding: 14px 0;
				border-bottom: 1px solid #EEEEEE;

				&:last-child {
					border-bottom: none;
				}

				.t1 {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 18px;
					color: #000000;
				}

				.jf {
					margin-top: 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #000000;

					span {
						margin-left: 4px;
						color: #00A73C;
					}
				}

				.status {
					height: 36px;
					line-height: 36px;
					background: linear-gradient(136deg, #7FDA4C 0%, #10B649 100%);
					border-radius: 11px 11px 11px 11px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					color: #FFFFFF;
					padding: 0 16px;

					&.status1 {
						background: #CCCCCC;
					}
				}

				.t2 {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
				}

				.t3 {
					font-family: DINPro, DINPro;
					font-weight: bold;
					font-size: 18px;
					color: #333333;
				}

				.time {
					margin-top: 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #999999;
				}
			}
		}
	}

	.editInfo {
		padding: 20px 36px;

		.tit {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 20px;
			color: #000000;
		}

		.headImg {
			margin: 30px 0;
			position: relative;

			.edit {
				position: absolute;
				bottom: -10px;
				left: 52%;
			}
		}

		.gbox {
			background: #F7F8F9;
			border-radius: 13px 13px 13px 13px;
			padding: 20px;

			.infoItem {
				padding: 10px 0;
			}

			.inpt {
				height: 36px;
				padding: 0 10px;
				line-height: 36px;
				background: #FFFFFF;
				border-radius: 9px 9px 9px 9px;
				border: 1px solid #EEEEEE;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333333;

				&:focus {
					outline: none;
				}
			}

			.t1 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}

			.change {
				margin-left: 6px;
				height: 20px;
				padding: 0 4px;
				border-radius: 4px 4px 4px 4px;
				border: 1px solid #00A73C;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #00A73C;
				line-height: 20px;
			}
		}
	}

	::v-deep .el-radio {
		margin-right: none;
		height: 36px;
		line-height: 36px;
		text-align: center;
		padding: 0 10px;
		background: rgba(255, 255, 255, 0.8);
		border-radius: 9px 9px 9px 9px;
		border: 1px solid #EEEEEE;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
		color: rgba(51, 51, 51, 0.8);
	}

	::v-deep .is-checked {
		border-color: #EEEEEE !important;
		background: rgba(0, 167, 60, 0.06);
	}

	::v-deep .el-radio__input.is-checked+.el-radio__label {
		color: rgba(0, 167, 60, 1) !important;
	}

	.changePhone {
		padding: 20px 30px;

		.tit {
			text-align: center;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 20px;
			color: #000000;
		}

		.ct1 {
			margin: 26px 0 6px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 20px;
			color: #333333;
		}

		.ct2 {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 300;
			font-size: 16px;
			color: #333333;
		}

		.inputbg {
			margin-top: 16px;
			height: 44px;
			line-height: 44px;
			background: #FFFFFF;
			border-radius: 13px 13px 13px 13px;
			border: 1px solid #EEEEEE;
			padding: 0 12px;
			border: 1px solid #EEEEEE;
			position: relative;

			.areacode {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 16px;
				color: #666666;
				margin-left: 13px;
			}

			.code {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 14px;
				color: #EACF8C;
				white-space: nowrap;
				position: absolute;
				right: 18px;
				cursor: pointer;
			}

			.sec {
				white-space: nowrap;
				position: absolute;
				right: 18px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 14px;
				color: #CCCCCC;
			}
		}

		.input {
			padding: 0 14px;
			outline: none;
			border: none;
			font-size: 16px;
			background: transparent;
			font-weight: 400;
			color: #000;
			font-family: HONOR Sans CN, HONOR Sans CN;
		}

		.input::placeholder {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #999999;
		}
	}

	.nodata {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		font-size: 18px;
		width: 100%;
		padding-top: 80px;
	}
</style>